"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CloseIconSmall = function (props) {
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none" }, props),
        react_1.default.createElement("path", { d: "M18.5 6L6.5 18", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M6.5 6L18.5 18", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = CloseIconSmall;
